import type { FC } from 'react';
import { Box, Grid2 } from '@mui/material';
import { NavLink, NavLinkTitle } from './NavLink';
import { NavProductionList, NavPlatformMap } from 'layouts/Main/constants';

interface IProps {
  activeLink: string;
}

const ProductionNav: FC<IProps> = ({ activeLink }) => {
  return (
    <Box sx={{ minWidth: '900px' }}>
      <Grid2 container spacing={2}>
        <Grid2 size={9}>
          <NavLinkTitle title="全球服务" />
          <Grid2 container size={12}>
            {NavProductionList.map((item) => (
              <Grid2
                size={4}
                display={'flex'}
                flex={'row'}
                justifyContent="space-between"
                alignItems={'flex-start'}
              >
                <Grid2 container>
                  <Grid2
                    size={12}
                    sx={{
                      fontWeight: 500,
                      fontSize: 13,
                      my: 1,
                      pl: 1,
                      color: '#1b1b1bb3',
                    }}
                  >
                    {item.title}
                  </Grid2>
                  <Grid2 size={12}>
                    {item.NavItem.map((sub) => (
                      <NavLink
                        activeLink={activeLink}
                        url={sub.href}
                        title={sub.label}
                      />
                    ))}
                  </Grid2>
                </Grid2>
              </Grid2>
            ))}
          </Grid2>
        </Grid2>
        <Grid2 size={3}>
          <NavLinkTitle title="sailglobal平台" />
          <Grid2 container size={12}>
            <Grid2
              size={12}
              sx={{
                fontWeight: 400,
                mt: 4,
              }}
              alignItems={'flex-start'}
            >
              <NavLink
                activeLink={activeLink}
                url={NavPlatformMap.href}
                title={NavPlatformMap.label}
              />
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default ProductionNav;
